// Prezzi mostrati: euro in italiano, dollari nelle altre lingue.
export const isEur = (lang) => lang === "it";

export const money = (lang, n) => {
  if (n === null || n === undefined) return "";
  const dec = Number.isInteger(Number(n)) ? 0 : 2;
  const s = Number(n).toLocaleString(isEur(lang) ? "it-IT" : "en-US", {
    minimumFractionDigits: dec,
    maximumFractionDigits: 2,
  });
  return isEur(lang) ? `${s}\u2009€` : `$${s}`;
};

// src = risposta di /public/founder oppure /subscription (chiavi *_usd + *_eur)
export const pick = (lang, src, usdKey, eurKey, fallbackUsd, fallbackEur) =>
  isEur(lang)
    ? src?.[eurKey] ?? fallbackEur
    : src?.[usdKey] ?? fallbackUsd;
